import React, { useContext, useEffect } from "react";
import { Redirect, Link } from "react-router-dom";
import Page from "components/Page";
import Products from "components/Products";
import { StoreContext } from "components/StoreContext";
import Loading from "components/Loading";
import FeaturedProducts from "components/FeaturedProducts";
import CatalogLinks from "components/Catalog";
import HeadTags from "components/HeadTags";

const Catalog = () => {
  const path = window.location.pathname;
  const { store, categories, getCategoryByPath, getCategoryById } = useContext(
    StoreContext
  );

  useEffect(() => {
    if (sessionStorage) {
      sessionStorage.setItem("continue", path);
    }
  }, [path]);

  if (store.loaded && categories.loaded) {
    if (getCategoryByPath(path)) {
      const category = getCategoryByPath(path);
      const { id, text, parent, color, lightIcon } = category;
      const parentCategory = getCategoryById(parent);
      if (id !== 0) {
        return (
          <>
            <HeadTags title={text} />
            <Page lightIcon={lightIcon} title={text} color={color}>
              {id !== 0 && (
                <div className="page__breadcrumb">
                  <ul>
                    <li>
                      <Link to="/catalog">Catalog</Link>
                    </li>
                    {parentCategory && parentCategory.id !== 0 && (
                      <li>
                        <Link to={parentCategory.path}>
                          {parentCategory.text}
                        </Link>
                      </li>
                    )}
                    <li>{text}</li>
                  </ul>
                </div>
              )}
              <FeaturedProducts
                endpoint={
                  category.id
                    ? `featured?categoryId=${category.id}`
                    : `featured`
                }
                title={`Featured Products in ${category.text}`}
              />
              <Products title={id === 0 ? "All" : text} category={id} />
            </Page>
          </>
        );
      }
      return (
        <>
          <HeadTags title="Catalog" />
          <Page title="Catalog" color="catalog">
            <CatalogLinks />
          </Page>
        </>
      );
    }
    return <Redirect to="/catalog" />;
  }
  return (
    <div className="site__loading">
      <Loading />
    </div>
  );
};

export default Catalog;
